import '../../styles/common/container.css';

function Container({ children }) {
    return (
        <main>
            {children}
        </main>
    );
}

export default Container;